<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template>
                        Edycja rodzaju wysyłki
                    </template>
                </h1>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-autocomplete
                            :value="transportTaskPropertyValue"
                            :items="filteredTransportWays"
                            item-value="name"
                            item-text="name"
                            label="Transport"
                            outlined
                            dense
                            clearable
                            hide-details
                            @change="changeTransportTaskPropertyValue"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            :value="distance"
                            label="Dystans"
                            :suffix="distanceSuffix"
                            outlined
                            dense
                            hide-details
                            :readonly="!isDedicatedDistantTransportType"
                            @input="handleDistance"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-mask="'######'"
                            :value="transportCost"
                            label="Koszt"
                            suffix="zł"
                            outlined
                            dense
                            hide-details
                            :readonly="isDedicatedTransportType"
                            @input="handleCost"
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Dodaj"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import { mask } from 'vue-the-mask'
import parse from '@/mixins/parse'

export default {
    name: 'SendingParametersDialog',
    directives: { mask },
    mixins: [ parse ],
    props: {
        isOpen: {
            type: Boolean
        },
        taskData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            task: {},
            factor: null,
            kilometers: null
        }
    },
    computed: {
        filteredTransportWays() {
            return this.transportTaskPropertyItems.filter(item => item.name !== 'CF - transport dedykowany')
        },
        transportTaskProperty() {
            return this.task.impositionTaskProperties?.find(item => item.productionProcessPropertyId === 10)
        },
        transportTaskPropertyItems() {
            if (this.transportTaskProperty) {
                return this.transportTaskProperty.productionProcessProperty.productionProcessPropertyValues
            }
            
            return []
        },
        transportTaskPropertyValue() {
            return this.transportTaskProperty ? this.transportTaskProperty.value : null
        },
        transportDistanceTaskProperty() {
            return this.task.impositionTaskProperties?.find(item => item.productionProcessPropertyId === 26)
        },
        transportCostTaskProperty() {
            return this.task.impositionTaskProperties?.find(item => item.productionProcessPropertyId === 20)
        },
        distanceSuffix() {
            return this.isDedicatedDistantTransportType ? 'km' : null
        },
        isDedicatedDistantTransportType() {
            if (this.transportTaskProperty === undefined) {
                return false
            } 
            const dedicatedDistantTransportTypes = this.transportTaskProperty.productionProcessProperty.productionProcessPropertyValues.filter(
                item => (item.fixedValue === null && item.factor !== null)
            )
            const result = dedicatedDistantTransportTypes.map(element => element.name)
        
            return result.includes(this.transportTaskProperty.value)
        },
        isDedicatedCloseTransportType() {
            if (this.transportTaskProperty === undefined) {
                return false
            }
            const dedicatedCloseTransportTypes = this.transportTaskProperty.productionProcessProperty.productionProcessPropertyValues.filter(
                item => (item.fixedValue === 1.0 && item.factor !== null)
            )
            const result = dedicatedCloseTransportTypes.map(element => element.name)
            
            return result.includes(this.transportTaskProperty.value) // Pila 1,3t & Pila 6,0t
        },
        isDedicatedTransportType() {
            return this.isDedicatedCloseTransportType || this.isDedicatedDistantTransportType
        },
        distance() {
            return this.transportDistanceTaskProperty ? this.transportDistanceTaskProperty.value : null
        },
        transportCost() {
            return this.transportCostTaskProperty ? this.transportCostTaskProperty.value : 0
        },
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.task = JSON.parse(JSON.stringify(this.taskData))
            } else {
                setTimeout(() => {
                    this.task = {}
                }, 500)
            }
        }
    },
    methods: {
        setDistanceValue() {
            this.task.impositionTaskProperties.find(item => item.productionProcessPropertyId === 26).value = '-'
        },
        changeTransportTaskPropertyValue(value) {
            this.transportTaskProperty.value = value
            this.getDataForCostCalculation(this.transportTaskProperty)
            this.clearTransportDistanceTaskProperty()
            this.clearTransportCostTaskProperty()
            if (this.transportTaskProperty.value === 'Transport klienta') {
                this.handleCost(0)
            }
            if (!this.isDedicatedDistantTransportType) {
                this.setDistanceValue()
            }
            if (this.isDedicatedCloseTransportType) {
                this.setTransportCostTaskPropertyValue()
            }
        },
        clearTransportDistanceTaskProperty() {
            this.transportDistanceTaskProperty.value = null
        },
        clearTransportCostTaskProperty() {
            this.task.impositionTaskProperties.find(item => item.productionProcessPropertyId === 20).value = null
        },
        setTransportCostTaskPropertyValue() {
            const cost = this.calculateCost(this.kilometers, this.factor)

            this.handleCost(cost)
        },
        calculateCost(distance, factor) {
            return Math.ceil(parseInt(distance) * factor).toString()

        },
        getCostCalculationData() {
            if (this.transportTaskproperty !== undefined) {
                const transportPropertyData = this.transportTaskProperty.productionProcessProperty.productionProcessPropertyValues.filter(
                    item => (item.name === this.transportTaskProperty.value)
                )
    
                if (transportPropertyData.length > 0) {
                    this.factor = transportPropertyData[0].factor
                    this.kilometers = transportPropertyData[0].fixedValue
                }
            }
        },
        handleDistance(value) {
            value = value ? value : 0
            this.getCostCalculationData()
            this.task.impositionTaskProperties.find(item => item.productionProcessPropertyId === 26).value = parseInt(value)
            this.kilometers = value

            const cost = this.calculateCost(value, this.factor)

            this.handleCost(cost)
        },
        handleCost(value) {
            this.task.impositionTaskProperties.find(item => item.productionProcessPropertyId === 20).value = value
        },
        getDataForCostCalculation(transportTaskProperty) {
            if (transportTaskProperty !== undefined) {
                const transportPropertyData = transportTaskProperty.productionProcessProperty.productionProcessPropertyValues.filter(
                    item => (item.name === transportTaskProperty.value)
                )
    
                if (transportPropertyData.length > 0) {
                    this.factor = transportPropertyData[0].factor
                    this.kilometers = transportPropertyData[0].fixedValue
                }
            }
        },
        onSave() {
            this.$emit('on-save', this.task)
        },
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>